<template>
    <div>
        <modal :show="password_reset_status == 'final'" @close="close" :closeOnbackdrop="false" :showClose="false" v-if="false">
            <template slot="header"><h3>Security Update</h3></template>
            <template>
                <template v-if="!isSuccess">
                    <p>
                        We are requiring all our customers to reset their password. 
                        Please click the button below and we will send a password reset link to your email.
                    </p>
                </template>
                <template v-else>
                    <p>
                        A password reset link was sent to <b>{{ email }}</b>. 
                        If you didn't receive any email 
                        <template v-if="isSubmitting"><b><span class="fa fa-spinner fa-pulse"></span></b></template>
                        <template v-else>
                            <a href="javascript:void(0);" @click="submit"><b>Click Here</b></a>
                        </template>
                        to try again.
                    </p>
                </template>
            </template>
            <template slot="footer">
                <template v-if="!isSuccess">
                    <button class="btn btn-black" type="button" :disabled="isSubmitting" @click="submit">
                        <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                        <template v-else>Send Password Reset Link</template>
                    </button>
                </template>
            </template>
        </modal>
    
        <div v-if="password_reset_status == 'warning' && false">
            <div v-if="!isSuccess" class="error-message alert alert-danger">
                <p class="mb-1">
                    <b>Security Update:</b> 
                    We are requiring all our customers to reset their password. 
                    You can still use your existing password before <u>{{ mandatory_reset_date | moment('MMMM DD, YYYY') }}</u>. 
                    Please click the button below and we will send a password reset link to your email.
                </p>
                <div class="text-right">
                    <button class="btn" type="button" :disabled="isSubmitting" @click="submit">
                        <template v-if="isSubmitting"><span class="fa fa-spinner fa-pulse"></span></template>
                        <template v-else>Send Password Reset Link</template>
                    </button>
                </div>
            </div>
            <div v-else class="success-message alert alert-success">
                <p class="mb-0">
                    A password reset link was sent to <b>{{ email }}</b>. 
                    If you didn't receive any email 
                    <template v-if="isSubmitting"><b><span class="fa fa-spinner fa-pulse"></span></b></template>
                    <template v-else>
                        <a href="javascript:void(0);" @click="submit"><b>Click Here</b></a>
                    </template>
                    to try again.
                </p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            isSubmitting: false,
            isSuccess: false,
            email: '',
            password_reset_status: '',
            mandatory_reset_date: '',
            model: {
                id: '',
                username: ''
            },
            user : {}
        }
    },
    watch: {
        '$route'() {
            this.check_user()
        }
    },
    mounted() {
        this.check_user()
    },
    methods: {
        check_user() {
            let user = localStorage.getItem('user')
            if(user) {
                user = JSON.parse(user)
                this.model.id = user.id
                this.model.username = user.username
                this.password_reset_status = user.password_reset_status
                this.mandatory_reset_date = user.mandatory_reset_date
                this.user = user
            }
        },
        submit() {
            this.isSubmitting = true
            this.check_user()

            this.$http.post('/api/reset_password_token', this.model)
                .then((res) => {
                    this.isSubmitting = false
                    this.isSuccess = true
                    this.$emit('done', true)
                    this.email = res.data.data.email
                })
                .catch(() => {
                    this.isSubmitting = false
                    this.$emit('done', false)
                })
        },
        close() {
            this.$emit('close', true)
        }
    }
}
</script>

<style lang="scss" scoped>
.error-message{
    color: #a94442;
    background-color: #f2dede;
    border-color: #ebccd1;
    padding: 10px 15px;
    margin-bottom: 8px;
    border: 1px solid transparent;
    border-radius: 4px;
}
.success-message{
    color: #155724;
    background-color: #d4edda;
    border-color: #c3e6cb;
    padding: 10px 15px;
    margin-bottom: 8px;
    border: 1px solid transparent;
    border-radius: 4px;
}
</style>